<template>
  <div class="login-wrap">
      <div class="login">
          <div class="login-header">
              <img src="../../static/image/head_logo.jpg" alt="">
          </div>
          <div class="login-content">
              <div class="username login-item">
                    <div class="username-left">用户名：</div>
                    <div class="username-right">
                        <el-input v-model="name" placeholder="请输入手机号"></el-input>
                    </div>
                </div>
                <div class="phone login-item">
                    <div class="phone-left">手机号：</div>
                    <div class="phone-right">
                        <el-input v-model="loginForm.phoneNumber" placeholder="请输入手机号"></el-input>
                        <el-button type="danger" @click="getCode()" :class="{'disabled-style':getCodeBtnDisable}" :disabled="getCodeBtnDisable">{{codeBtnWord}} </el-button>
                    </div>
                </div>
                <div class="code login-item">
                    <div class="code-left">短信验证码：</div>
                    <div class="code-right">
                        <el-input v-model="loginForm.verificationCode" placeholder="请输入验证码"></el-input>
                    </div>
                </div>
                <div class="submit">
                    <el-button type="danger" @click="submit">登录</el-button>
                </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    name:'Login',
    data(){
        return {
            name: '',
            loginForm: {
                phoneNumber: '',
                verificationCode: '',
            },
            codeBtnWord: '获取验证码', // 获取验证码按钮文字
            waitTime: 61, // 获取验证码按钮失效时间
            dealerList: [],
            isMore: false,
            submitInfo: {}
        }
    },
    computed: {
        // 用于校验手机号码格式是否正确
        phoneNumberStyle() {
            let reg = /^1[3456789]\d{9}$/
            if (!reg.test(this.loginForm.phoneNumber)) {
                return false
            }
            return true
        },
        // 控制获取验证码按钮是否可点击
        getCodeBtnDisable: {
            get() {
                if (this.waitTime == 61) {
                    if (this.loginForm.phoneNumber) {
                        return false
                    }
                    return true
                }
                return true
            },
            // 注意：因为计算属性本身没有set方法，不支持在方法中进行修改，而下面我要进行这个操作，所以需要手动添加
            set() {}
        }
    },
    methods:{
        // 发送验证码
        getCode() {
            //验证倒计时
            this.flag = true; //点击之后设置按钮不可取
            this.content = this.totalTime + "s后重新发送"; //按钮内文本
            let clock = window.setInterval(() => {
                this.totalTime--;
                this.content = this.totalTime + "s后重新发送";
                if (this.totalTime < 0) {
                    window.clearInterval(clock);
                    this.content = "重新发送验证码";
                    this.totalTime = 60;
                    this.flag = false; //这里重新开启
                }
            }, 1000);

            if (this.phoneNumberStyle) {
                let params = {}
                params.phone = this.loginForm.phoneNumber
                // 调用获取短信验证码接口
                //短信验证码
                this.getSmsCode(this.loginForm.phoneNumber)
                // 因为下面用到了定时器，需要保存this指向
                let that = this;
                that.waitTime--;
                that.getCodeBtnDisable = true;
                this.codeBtnWord = `${this.waitTime}s 后重新获取`
                let timer = setInterval(function () {
                    if (that.waitTime > 1) {
                        that.waitTime--
                        that.codeBtnWord = `${that.waitTime}s 后重新获取`
                    } else {
                        clearInterval(timer)
                        that.codeBtnWord = '获取验证码'
                        that.getCodeBtnDisable = false
                        that.waitTime = 61
                    }
                }, 2000)
            }
        },
         //获取短信验证码
        async getSmsCode(phone) {
            const result = await this.$http.goCatPreferential.getSmsCode({
                number: phone
            })
            if (result.code == 200) {
                this.$message({
                    message: '验证码已发送，请稍候...',
                    type: 'success',
                    center: true,
                    offset: 140
                })
            }

        },
        // 提交报名信息
        async submit() {
            const sumitObj = {
                uname: this.name,
                number: this.loginForm.phoneNumber,
                code: this.loginForm.verificationCode,
            }

            const result = await this.$http.signUp.doMobileLogin(sumitObj);
            if (result.code === 200) {
                window.localStorage.setItem('uid', result.data.uid)
                this.$router.push('/gocat')
            } else {
                this.$message({
                    message: '请完整填写登录信息。。。',
                    type: 'error',
                    center: true,
                    offset: 140
                })
                return
            }
            

        },
    }
}
</script>

<style lang="less">
    .login-wrap{
        .login{
            .login-header{
                height: 160px;
                img{
                    height: 160px;
                    margin: 0 auto;
                }
            }
            .login-content{
                margin-top: 130px;
                padding: 0 20px;
                font-size: 38px;
                .login-item{
                    height: 100px;
                    display: flex;
                    .phone-right{
                        position: relative;
                        .el-button{
                            width: 25vw;
                            height: 60px;
                            position: absolute;
                            top: 0;
                            right: -26vw;
                            font-size: 24px;
                        }
                    }
                }
                .submit{
                    text-align: center;
                    margin-top: 30px;
                     .el-button{
                            width: 30vw;
                            height: 80px;
                            font-size: 40px;

                        }
                }
                .el-input{
                    height: 80px;
                    .el-input__inner{
                        height: 60px;
                        border: 1px solid #66b1ff;
                        font-size: 30px;
                        width: 50vw;
                    }
                }
            }
        }
    }
</style>
